/* eslint-disable no-plusplus */
/* eslint-disable indent */
import { environment } from 'environments';

class MedicationsListController {
  /* @ngInject */
  constructor(
    $state,
    $log,
    $interval,
    Business,
    Endpoints,
    Discounts,
    Promos,
    Services,
    Notifications,
    MedicationPrice,
    toastr,
    MedicationService,
    $timeout,
    Users,
    Auth,
  ) {
    Object.assign(this, {
      $state,
      $log,
      $interval,
      Business,
      Endpoints,
      Discounts,
      Promos,
      Services,
      Notifications,
      MedicationPrice,
      toastr,
      MedicationService,
      $timeout,
      Users,
      Auth,
      environment: environment.constants.ENV,
      adding: false,
      services: [],
      selectedService: '',
      medicationEdit: {},
      // onlineChargeTypes: [
      //   {
      //     "id": 0,
      //     "code": "Default",
      //     "description": "This is the default selection"
      //   },
      //   {
      //     "id": 1,
      //     "code": "Help me choose",
      //     "description": "Help me choose medication"
      //   },
      //   {
      //     "id": 2,
      //     "code": "Photo diagnosis",
      //     "description": "Photo diagnosis medication"
      //   }
      // ],
      shipment_options: [
        { label: 'Standard', value: 'standard' },
        { label: 'Signature Required', value: 'signature required' },
        { label: 'Special Delivery', value: 'special delivery' },
      ],
      shipment_weights: {
        0: { label: '2kg', value: 0 },
        1: { label: '5kg', value: 1 },
      },
      dispense_units: [
        { label: 'Applicator', value: 'applicator' },
        { label: 'Capsule', value: 'capsule' },
        { label: 'Pessary', value: 'pessary' },
        { label: 'Dose', value: 'dose' },
        { label: 'Grams', value: 'g' },
        { label: 'Inhaler', value: 'inhaler' },
        { label: 'Injection', value: 'injection' },
        { label: 'Millilitre', value: 'ml' },
        { label: 'Patch', value: 'patch' },
        { label: 'Pen', value: 'pen' },
        { label: 'Sachet', value: 'sachet' },
        { label: 'Tablet', value: 'tablet' },
        { label: 'Unit Dose', value: 'unit dose' },
        { label: 'Spray', value: 'spray' },
        { label: 'Suppository', value: 'suppository' },
      ],
      BODACDC_1097: FEATURE_BODACDC_1097,
    });
    this.getTreatmentPlanList();
    this.getAllServices();
    this.getChargeType();
    this.getDispenseUnits();
  }

  preview(row) {
    const url = this.$state.href('treatment', {
      id: row.treatment_plan_code,
    });
    window.open(url, '_blank');
  }
  edit(row) {
    if (!_.includes(this.Auth.profile.roles, this.Users.ROLES.DOCTOR_ADMIN.NAME)) {
      this.toastr.warning('You need the role Doctor Admin to edit medications.');
      return;
    }

    this.editing = true;
    this.medication_id = row.medication_id;
    this.medication_code = row.medication_code;
    this.medication_name = row.medication_name;
    this.selectedTreatmentPlan = row.treatment_plan_code || '';
    this.treatment_plan_code = row.treatment_plan_code;
    this.$timeout(() => {
      $('#treament-plan-id').focus();
    }, 500); // TO REFRESH TREATMENT PLAN CODES
    // WHEN USER CLICKS EDIT BUTTON

    this.getTreatmentPlanList('editing', row.treatment_plan_code);
    this.getMedicationById(row.medication_id);
  }

  getChargeType() {
    this.MedicationService.getOnlineChargeTypes().then(({ data }) => {
      this.onlineChargeTypes = data;
    });
  }

  getDispenseUnits() {
    this.MedicationService.getDispenseUnits().then(({ data }) => {
      this.dispense_units =
        data?.filter(unit => unit.is_active).map(({ value, unit }) => ({ label: unit, value: value })) || [];
    });
  }

  updateMedication(medication) {
    if (!this.selectedTreatmentPlan) {
      this.toastr.warning('Please select a treatment plan.');
      return;
    }

    for (const pam in this.medicationEdit.pamsOutput) {
      this.medicationEdit.pamsOutput[pam] =
        this.medicationEdit.pamsOutput[pam] && this.medicationEdit.pamsOutput[pam].length
          ? this.medicationEdit.pamsOutput[pam][0]
          : null;
    }
    for (const ram in this.medicationEdit.ramsOutput) {
      this.medicationEdit.ramsOutput[ram] =
        this.medicationEdit.ramsOutput[ram] && this.medicationEdit.ramsOutput[ram].length
          ? this.medicationEdit.ramsOutput[ram][0]
          : null;
    }

    const messageTemplatesPayload = {};
    messageTemplatesPayload[this.selectedCategory.code] = {
      PAMs: this.medicationEdit.pamsOutput,
      RAMs: this.medicationEdit.ramsOutput,
    };

    const payload = {
      medical_name: medication.name,
      treatment_copy_code: this.selectedTreatmentPlan.combined_code,
      default_short_directions: medication.default_short_directions,
      default_days_supply: medication.default_days_supply,
      default_dispense_amount: medication.default_dispense_amount,
      default_num_refills: medication.default_num_refills,
      default_pharmacy_notes: medication.default_pharmacy_notes,
      default_no_substitutions: medication.default_no_substitutions,
      charge_type_id: medication.charge_type_id,
      charge_at_checkout: medication.charge_at_checkout,
      prevent_addition_to_rx: medication.prevent_addition_to_rx,
      shipment_option: medication.shipment_option,
      shipment_sub_option: medication.shipment_weight.value,
      stock_code1: medication.stock_code1,
      stock_code2: medication.stock_code2,
      stock_code3: medication.stock_code3,
      stock_code4: medication.stock_code4,
      stock_code5: medication.stock_code5,
      message_templates: messageTemplatesPayload,
      min_age: medication.min_age,
      max_age: medication.max_age,
      dispense_unit: medication.dispense_unit,
      ...(FEATURE_BODACDC_1097 && { cold_chain: medication.cold_chain || false }),
    };

    if (this.medication_name !== medication.name) payload.name = medication.name;

    this.updating = true;
    this.MedicationService.updatePimsMedication(this.medication_id, payload)
      .then(() => {
        this.toastr.success('PIMS medication was updated successfully.');
        this.medications.forEach((med, index) => {
          if (med.medication_id === this.medication_id) {
            this.medications[index].medication_name = medication.name;
            this.medications[index].treatment_plan_code = this.selectedTreatmentPlan.combined_code;
          }
        });
        this.medicationEdit = {};
        this.adding = false;
        this.editing = false;
      })
      .catch(err => {
        if (err && err.data && err.data.message && err.data.message.summary) {
          this.toastr.error(`CATCH Error: ${err.data.message.summary}`);
        } else {
          this.toastr.error(`CATCH Generic Error: ${this.Notifications.generic.failure}`);
        }
      })
      .finally(() => {
        this.updating = false;
      });
  }

  add() {
    if (!_.includes(this.Auth.profile.roles, this.Users.ROLES.DOCTOR_ADMIN.NAME)) {
      this.toastr.warning('You need the role Doctor Admin to add medications.');
      return;
    }

    this.adding = true;
    this.medicationQuery = '';
    this.$timeout(() => {
      $('#createNewMedicationId').focus();
    }, 500); // TO REFRESH TREATMENT PLAN CODES
    // WHEN USER CLICKS ADD BUTTON

    this.getTreatmentPlanList('adding');
  }

  shipmentOptionChanged() {
    if (!this.isShipmentOptionSpecialDelivery()) {
      this.medicationEdit.shipment_weight = this.shipment_weights[this.medicationEdit.shipment_sub_option];
    }
  }

  isShipmentOptionSpecialDelivery() {
    return this.medicationEdit.shipment_option === 'special delivery';
  }

  goBack() {
    this.adding = false;
    this.editing = false;
    this.medicationEdit = {};
  }

  addMedication() {
    if (!this.medicationQuery) {
      this.toastr.warning("Please enter medication's name.");
      return;
    }

    if (this.selectedTreatmentPlan.combined_code === 'Select a treatment plan') {
      this.toastr.warning('Please select a treatment plan.');
      return;
    }

    const payload = {
      name: this.medicationQuery,
      treatment_copy_code: this.selectedTreatmentPlan.combined_code,
      categories: [
        {
          code: this.selectedService,
          product_sku_id: null,
        },
      ],
    };

    this.creating = true;

    this.MedicationService.createPimsMedication(payload)
      .then(() => {
        this.toastr.success('PIMS medication was created successfully.');
        this.adding = false;
        this.editing = false;
        this.getMedicationsByCategory();
      })
      .catch(err => {
        if (err && err.data && err.data.message && err.data.message.summary) {
          this.toastr.error(`Error: ${err.data.message.summary}`);
        } else {
          this.toastr.error(this.Notifications.generic.failure);
        }
      })
      .finally(() => {
        this.creating = false;
      });
  }

  getFilteredMedications(query) {
    return this.MedicationService.searchLemonaidMedications(this.selectedService, query).then(
      ({ data: medications }) => medications,
    );
  }

  changeCategory() {
    this.getMedicationsByCategory();
  }

  getMedicationsByCategory() {
    this.Services.getMedicationListByCategory(this.selectedCategory.code)
      .then(({ data }) => {
        data.sort((a, b) => {
          if (a.medication_name < b.medication_name) {
            return -1;
          }
          if (a.medication_name > b.medication_name) {
            return 1;
          }
          return 0;
        });

        this.medications = data;
      })
      .catch(err => {
        this.medications = [];
        this.toastr.error(`Error getting medications by service: ${JSON.stringify(err)}`);
      });
  }

  toggleSelectedListItem(item, list, code) {
    const selectedList = this.medicationEdit[list][code].ams.filter(am => am.selected);
    if (selectedList.length > 1) {
      selectedList.find(am => am.code !== item.code).selected = false;
    }
  }

  getPAMS(pam_code) {
    this.MedicationService.getMessageTemplateOverrideList(pam_code).then(({ data }) => {
      let selected_PAM_code = null;
      if (this.medicationEdit.pamsList[pam_code].ams.length) {
        selected_PAM_code = this.medicationEdit.pamsList[pam_code].ams.find(pam => pam.selected);
        if (selected_PAM_code) {
          selected_PAM_code = selected_PAM_code.code;
        }
      }
      this.medicationEdit.pamsList[pam_code].ams = data.map(pam => ({
        ...pam,
        name: pam.name || 'Not Applied',
        selected: selected_PAM_code === pam.code,
        status: `<i class="icon-dot ${pam.is_active ? 'color-success' : 'color-alert'}"></i>`,
      }));
    });
  }

  getRAMS(ram_code) {
    this.MedicationService.getMessageTemplateOverrideList(ram_code).then(({ data }) => {
      let selected_RAM_code = null;
      if (this.medicationEdit.ramsList[ram_code].ams.length) {
        selected_RAM_code = this.medicationEdit.ramsList[ram_code].ams.find(ram => ram.selected).code;
      }
      this.medicationEdit.ramsList[ram_code].ams = data.map(ram => ({
        ...ram,
        name: ram.name || 'Not Applied',
        selected: selected_RAM_code === ram.code,
        status: `<i class="icon-dot ${ram.is_active ? 'color-success' : 'color-alert'}"></i>`,
      }));
    });
  }

  getMedicationById(medication_id) {
    this.MedicationService.getPimsMedication(medication_id)
      .then(data => {
        if (data.message_templates && data.message_templates[this.selectedCategory.code]) {
          const { PAMs: pams, RAMs: rams } = data.message_templates[this.selectedCategory.code];
          if (pams) {
            data.pamsList = {};
            data.pamsOutput = {};
            Object.entries(pams).forEach(([code, pam]) => {
              data.pamsList[code] = {
                ams: [],
                parent_is_active: pam.parent_is_active,
              };
              data.pamsList[code].ams.push({
                ...pam,
                name: pam.page_name
                  ? pam.page_name
                  : pam.parent_is_active
                    ? 'Service Level Automated Message'
                    : 'Service Level Disabled',
                selected: true,
              });
            });
          }
          if (rams) {
            data.ramsList = {};
            data.ramsOutput = {};
            Object.entries(rams).forEach(([code, ram]) => {
              data.ramsList[code] = {
                ams: [],
                parent_is_active: ram.parent_is_active,
              };
              data.ramsList[code].ams.push({
                ...ram,
                name: ram.page_name
                  ? ram.page_name
                  : ram.parent_is_active
                    ? 'Service Level Automated Message'
                    : 'Service Level Disabled',
                selected: true,
              });
            });
          }
        }
        this.medicationEdit = {
          ...data,
          shipment_weight: Number.isInteger(data.shipment_sub_option)
            ? this.shipment_weights[data.shipment_sub_option]
            : null,
        };
      })
      .catch(err => {
        this.toastr.error(`Error getting stock codes: ${JSON.stringify(err)}`);
      });
  }

  getTreatmentPlanList(action = null) {
    this.Services.getTreatmentPlanList('published')
      .then(({ data }) => {
        this.treatmentPlans = data;
        if (this.treatment_plan_code && !this.treatmentPlans.find(x => x.combined_code === this.treatment_plan_code)) {
          this.treatmentPlans.push({ combined_code: this.treatment_plan_code });
        }

        if (this.treatment_plan_code) {
          this.selectedTreatmentPlan = this.treatment_plan_code;
        } else {
          this.selectedTreatmentPlan = 'Generic-Treatment-Plan';
        }

        if (action && action === 'adding') {
          this.selectedTreatmentPlan = this.treatmentPlans.find(x => x.combined_code === 'Generic-Treatment-Plan');
        } else if (action && action === 'editing') {
          this.selectedTreatmentPlan = this.treatmentPlans.find(x => x.combined_code === this.treatment_plan_code);
        }
      })
      .catch(err => {
        this.treatmentPlans = [];
        this.toastr.error(`Error getting treatment plan list: ${JSON.stringify(err)}`);
      });
  }

  getAllServices() {
    this.Services.list()
      .then(({ data }) => {
        const servicesArr = [];
        for (let i = 0; i < data.data.length; i++) {
          if (data.data[i].children) {
            for (let j = 0; j < data.data[i].children.length; j++) {
              servicesArr.push({
                id: data.data[i].children[j].id,
                code: data.data[i].children[j].code,
                name: `${data.data[i].children[j].name} (${data.data[i].children[j].code})`,
              });
            }
            // eslint-disable-next-line no-continue
            continue;
          }
          servicesArr.push({
            id: data.data[i].id,
            code: data.data[i].code,
            name: `${data.data[i].name} (${data.data[i].code})`,
          });
        }

        servicesArr.sort((a, b) => {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        });

        const elem = {
          id: 0,
          code: 'SELECT',
          name: 'Select a service',
        };
        servicesArr.unshift(elem);
        this.services = angular.copy(servicesArr);
        this.categories = angular.copy(servicesArr);
        this.selectedService = 'SELECT';
      })
      .catch(err => {
        this.services = [];
        this.categories = [];
        this.toastr.error(`Error getting all services: ${JSON.stringify(err)}`);
      });
  }
}

MedicationsListController.$inject = [
  '$state',
  '$log',
  '$interval',
  'Business',
  'Endpoints',
  'Discounts',
  'Promos',
  'Services',
  'Notifications',
  'MedicationPrice',
  'toastr',
  'MedicationService',
  '$timeout',
  'Users',
  'Auth',
];
angular.module('pims').controller('MedicationsListController', MedicationsListController);
